import PropTypes from 'prop-types'

export default (
  PropTypes.shape({
    tickets: PropTypes.arrayOf(Object).isRequired,
    counts: PropTypes.instanceOf(Object).isRequired,
  })
)
